// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"2425c942","189":"9740f0cb","216":"04db17c3","236":"79a1f489","260":"7ff5e72f","281":"9ea4397e","449":"52f8d70a","533":"73b68aeb","544":"2e963927","566":"e52aec42","722":"bf2a92dc","846":"28a9ac09","962":"0f534e2f","977":"8e97521d"}[chunkId] + ".chunk.js";
};